<template>
    <div class="col-md-4 col-lg-3 order-1 order-md-2 mb-5">
        <div class="form-group">
            <label for="release-sort-title" class="font-weight-bolder">{{ $t('company.title') }}</label>
            <input id="release-sort-title" v-model="form.titleCompany.value" type="text" :placeholder="$t('company.title')" class="form-control form-control-sm" autofocus>
        </div>
        <div class="form-group">
            <label for="release-sort-title" class="font-weight-bolder">{{ $t('company.alias') }}</label>
            <input id="release-sort-title" v-model="form.aliasCompany.value" type="text"  :placeholder="$t('company.alias')" class="form-control form-control-sm" autofocus>
        </div>
        <div class="d-flex gap-2">
            <a :href="$route.path" class="btn btn-block btn-outline-secondary btn-sm m-0">{{ $t('company.reset') }}</a>
            <a :href="`${$route.path}?title=${form.titleCompany.value}&companyAlias=${form.aliasCompany.value}`" class="btn btn-block btn-sm btn-primary m-0">{{ $t('company.search') }}</a>
        </div>
    </div>
</template>
<script>
import CompanyMessages from '@/shared-modules/modules/company/company.messages';

export default {
    data() {
        return {
            form: {
                titleCompany: {
                    value: this.$route.query.title || ''
                },
                aliasCompany: {
                    value: this.$route.query.companyAlias || ''
                }
            }
        }
    },
    watch: {
        '$route.query': {
            handler() {
                this.updateFormFromQuery();
            },
            immediate: true
        }
    },
    methods: {
        updateFormFromQuery() {
            this.form.titleCompany.value = this.$route.query.title || '';
            this.form.aliasCompany.value = this.$route.query.companyAlias || '';
        },
    },
    i18n: { messages: CompanyMessages }
}
</script>
